import notify from "devextreme/ui/notify";
import { useHistory } from "react-router-dom";
import { createRoute } from "../../../../utils/url";
import { buildServiceProductPayload } from "../helper/periodHelpers";
import { serviceProductValidationSchema } from "../helper/serviceProductValidation";
import { ServiceProductCreatable } from "../types";

const useFormSubmission = (
  onSubmit: (serviceProduct: ServiceProductCreatable) => void,
  solutionKey: Key
) => {
  const history = useHistory();

  const submitForm = async (
    values: Partial<ServiceProductCreatable>,
    { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }
  ) => {
    try {
      const payload: ServiceProductCreatable =
        buildServiceProductPayload(values);
      serviceProductValidationSchema.validateSync(
        { ...values },
        { abortEarly: false }
      );
      await Promise.resolve(onSubmit(payload));
      history.push(createRoute(`/solutions/${solutionKey}/service-products`));
    } catch (err) {
      notify("Unexpected Validation error: " + err, "error", 3000);
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
  };

  return { submitForm };
};

export default useFormSubmission;
